// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { Message } from "./Message.ts"
import { PFixMessage } from "./PFixMessage.js"
export let TradingSignalRequestMessage = function (fieldSet)
{
    this.Code = Message.CODE_TRADING_SIGNALS_REQ_MESSAGE;
    PFixMessage.call(this, fieldSet);
}
TradingSignalRequestMessage.prototype = Object.create(PFixMessage.prototype);